import React from "react"
import { connect } from "react-redux"
import { firestoreConnect } from "react-redux-firebase"
import { compose } from "redux"

import SimpleHeader from "components/Headers/SimpleHeader.js"
import { CustomPagination } from "components/Common"

import {
  Card,
  CardHeader,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  UncontrolledDropdown,
  Media,
  Table,
  Container,
  Row,
} from "reactstrap"

class Orders extends React.Component {
  state = {
    start: 0,
    end: 0,
  }

  _handlePaginationClick(start, end) {
    if (start >= 0 && end >= 0) {
      this.setState({
        start,
        end,
      })
    }
  }

  _getOrderPlacementTime(time) {
    // order.time.toDate().getHours() + ':' + order.time.toDate().getMinutes()
    let ret = ""
    if (time) {
      let hours = time.getHours().toString()
      let minutes = time.getMinutes().toString()
      hours = hours.length === 1 ? "0" + hours : hours
      minutes = minutes.length === 1 ? "0" + minutes : minutes
      ret = `${hours}:${minutes}`
      // console.log(ret);
    }
    return ret
  }

  render() {
    const { orders } = this.props
    const { start, end } = this.state
    return (
      <>
        <SimpleHeader name="Orders" parentName="Orders" />
        <Container className="mt--6" fluid>
          <Row>
            <div className="col">
              <Card>
                <CardHeader className="border-0">
                  <h3 className="mb-0">Orders</h3>
                </CardHeader>
                <Table className="align-items-center table-flush" responsive>
                  <thead className="text-center thead-light">
                    <tr>
                      <th className="sort" data-sort="name" scope="col">
                        Merchant
                      </th>
                      <th className="sort" data-sort="name" scope="col">
                        Customer
                      </th>
                      <th className="sort" data-sort="name" scope="col">
                        Order Details
                      </th>
                      <th className="sort" data-sort="status" scope="col">
                        Cost
                      </th>
                      <th className="sort" data-sort="status" scope="col">
                        Order Creation
                      </th>
                      <th className="sort" data-sort="status" scope="col">
                        Order Date
                      </th>
                      <th className="sort" data-sort="status" scope="col">
                        Order Time
                      </th>
                      <th className="sort" data-sort="status" scope="col">
                        Order Duration
                      </th>
                      <th className="sort" data-sort="status" scope="col">
                        Order Id
                      </th>
                      <th scope="col" />
                    </tr>
                  </thead>
                  <tbody className="text-center list">
                    {orders &&
                      orders.length > 0 &&
                      orders.slice(start, end).map((order) => {
                        return (
                          <tr key={order.id}>
                            <th scope="row">
                              <Media className="align-items-center">
                                <a
                                  className="avatar rounded-circle mr-3"
                                  href="#fa"
                                  onClick={(e) => e.preventDefault()}
                                >
                                  <img
                                    alt="..."
                                    src={
                                      order.merchantLogo ||
                                      require("assets/img/theme/blank-profile.png")
                                    }
                                  />
                                </a>
                                <Media>
                                  <span className="name mb-0 text-sm">
                                    {order.merchantName || ""}
                                  </span>
                                </Media>
                              </Media>
                            </th>
                            <td>{order.firstName + " " + order.lastName}</td>
                            <td>
                              {order.addressLine1 +
                                ", " +
                                (order.addressLine2
                                  ? order.addressLine2 + ", "
                                  : "") +
                                order.city +
                                ", " +
                                order.zipCode}
                              <br />
                              {order.phone}
                            </td>
                            <td>{order.totalCost}</td>
                            <td>
                              {order.time.toDate().toDateString()}
                              <br />
                              {/* {order.time.toDate().getHours() + ':' + order.time.toDate().getMinutes()} */}
                              {this._getOrderPlacementTime(order.time.toDate())}
                            </td>
                            <td>
                              {order.orderDate.toDate().toDateString()}
                              <br />
                            </td>
                            <td>{order.orderTime}</td>
                            <td>{(order.orderDuration || "") + " Min"}</td>
                            <td>{order.orderId || ""}</td>
                            <td className="text-right">
                              <UncontrolledDropdown>
                                <DropdownToggle
                                  className="btn-icon-only text-light"
                                  color=""
                                  role="button"
                                  size="sm"
                                >
                                  <i className="fas fa-ellipsis-v" />
                                </DropdownToggle>
                                <DropdownMenu
                                  className="dropdown-menu-arrow"
                                  right
                                >
                                  <DropdownItem
                                    disabled={true}
                                    href="#fa"
                                    onClick={(e) => e.preventDefault()}
                                  >
                                    Edit
                                  </DropdownItem>
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            </td>
                          </tr>
                        )
                      })}
                  </tbody>
                </Table>
                <CustomPagination
                  pageSize={10}
                  dataLen={this.props.orders ? this.props.orders.length : 0}
                  stateCallback={this._handlePaginationClick.bind(this)}
                />
              </Card>
            </div>
          </Row>
        </Container>
      </>
    )
  }
}

const mapStateToProps = (state) => {
  // console.log(state);
  return {
    orders: state.firestore.ordered.orders,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect((props) => [
    {
      collection: `orders`,
      storeAs: "orders",
    },
  ])
)(Orders)
